import * as React from "react";
import Svg, {
  Mask,
  Circle,
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
} from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={160} height={160} viewBox="0 0 160 160" fill="none" {...props}>
      <Mask
        id="prefix__a"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={160}
        height={160}
      >
        <Circle cx={80} cy={80} r={80} fill="#C4C4C4" />
      </Mask>
      <G mask="url(#prefix__a)">
        <Mask id="prefix__b" fill="#fff">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.796 79.047L35.27 74.9c1.982 5.991 8.322 9.465 14.495 7.81 6.173-1.653 9.926-7.831 8.648-14.01l15.474-4.147a6 6 0 017.349 4.243l32.093 119.774a6 6 0 01-4.242 7.349l-14.445 3.87a13.1 13.1 0 00-.117-.472c-1.816-6.778-8.782-10.8-15.56-8.984-6.777 1.816-10.799 8.783-8.983 15.56.043.157.087.313.135.468l-15.122 4.052a6 6 0 01-7.348-4.243L15.553 86.395a6 6 0 014.243-7.348z"
          />
        </Mask>
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.796 79.047L35.27 74.9c1.982 5.991 8.322 9.465 14.495 7.81 6.173-1.653 9.926-7.831 8.648-14.01l15.474-4.147a6 6 0 017.349 4.243l32.093 119.774a6 6 0 01-4.242 7.349l-14.445 3.87a13.1 13.1 0 00-.117-.472c-1.816-6.778-8.782-10.8-15.56-8.984-6.777 1.816-10.799 8.783-8.983 15.56.043.157.087.313.135.468l-15.122 4.052a6 6 0 01-7.348-4.243L15.553 86.395a6 6 0 014.243-7.348z"
          fill="url(#prefix__paint0_linear)"
        />
        <Path
          d="M35.27 74.9l1.899-.628-.593-1.792-1.824.489.518 1.931zm23.143-6.2l-.518-1.933-1.823.489.382 1.848 1.959-.405zm36.23 131.089l-1.95.445.461 2.024 2.006-.537-.518-1.932zm-24.526 6.572l.518 1.931 2.006-.537-.613-1.984-1.91.59zM34.752 72.969l-15.474 4.146 1.035 3.864 15.475-4.147-1.036-3.863zm14.495 7.81c-5.143 1.378-10.427-1.517-12.078-6.507l-3.798 1.257c2.314 6.99 9.709 11.044 16.912 9.114l-1.036-3.864zm7.207-11.675c1.065 5.148-2.063 10.297-7.207 11.675l1.036 3.864c7.202-1.93 11.58-9.138 10.088-16.349l-3.917.81zm16.916-6.483l-15.475 4.146 1.035 3.864 15.475-4.146-1.035-3.864zm9.798 5.657a8 8 0 00-9.798-5.657l1.035 3.864a4 4 0 014.899 2.828l3.864-1.035zm32.093 119.775L83.168 68.278l-3.864 1.035 32.094 119.775 3.863-1.035zm-5.657 9.798a8 8 0 005.657-9.798l-3.863 1.035a4 4 0 01-2.829 4.899l1.035 3.864zm-14.444 3.87l14.444-3.87-1.035-3.864-14.444 3.87 1.035 3.864zm-2.566-1.887c.035.134.068.267.099.4l3.9-.889a15.092 15.092 0 00-.136-.546l-3.863 1.035zm-13.11-7.569c5.71-1.53 11.58 1.859 13.11 7.569l3.863-1.035c-2.102-7.844-10.165-12.499-18.009-10.397l1.035 3.863zm-7.57 13.11c-1.53-5.71 1.859-11.58 7.57-13.11l-1.036-3.863c-7.844 2.102-12.5 10.164-10.397 18.009l3.863-1.036zm.114.396c-.04-.131-.078-.262-.114-.396l-3.864 1.036c.05.181.101.361.156.54l3.822-1.18zm-16.515 6.573l15.122-4.052-1.036-3.863-15.122 4.052 1.036 3.863zm-9.798-5.656a8 8 0 009.798 5.656l-1.036-3.863a4 4 0 01-4.899-2.829l-3.863 1.036zM13.62 86.913l32.094 119.775 3.863-1.036L17.485 85.878l-3.864 1.035zm5.657-9.798a8 8 0 00-5.657 9.798l3.864-1.035a4 4 0 012.828-4.9l-1.035-3.863z"
          fill="#FFC78A"
          mask="url(#prefix__b)"
        />
        <Path
          d="M49.129 109.949c.354-.095.723.116.778.478a6.003 6.003 0 01-1.758 5.213 5.993 5.993 0 01-5.267 1.59c-.36-.067-.559-.442-.453-.793.107-.351.478-.544.84-.489a4.673 4.673 0 005.344-5.175c-.044-.364.162-.729.516-.824zM64.014 105.438c-.367-.009-.675.282-.644.647a5.996 5.996 0 002.423 4.315 6.004 6.004 0 004.841 1.027c.359-.079.545-.46.427-.807-.118-.348-.495-.529-.856-.462a4.662 4.662 0 01-3.625-.828 4.675 4.675 0 01-1.871-3.213c-.043-.365-.329-.671-.695-.679z"
          fill="#665848"
        />
        <Path
          d="M67.054 122.502c.45-.121.722-.586.552-1.02a7.622 7.622 0 00-14.635 3.921c.07.461.538.728.988.608.45-.121.71-.584.655-1.047a5.933 5.933 0 018.86-5.847 5.933 5.933 0 012.49 2.806c.183.429.64.699 1.09.579z"
          fill="#FFB86B"
        />
        <Mask id="prefix__c" fill="#fff">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M77 74.524h16.02c.365 6.3 5.59 11.296 11.98 11.296 6.391 0 11.615-4.996 11.98-11.296H133a6 6 0 016 6v124a6 6 0 01-6 6h-15.517c.006-.161.01-.323.01-.486 0-7.017-5.688-12.705-12.705-12.705-7.016 0-12.704 5.688-12.704 12.705 0 .163.003.325.009.486H77a6 6 0 01-6-6v-124a6 6 0 016-6z"
          />
        </Mask>
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M77 74.524h16.02c.365 6.3 5.59 11.296 11.98 11.296 6.391 0 11.615-4.996 11.98-11.296H133a6 6 0 016 6v124a6 6 0 01-6 6h-15.517c.006-.161.01-.323.01-.486 0-7.017-5.688-12.705-12.705-12.705-7.016 0-12.704 5.688-12.704 12.705 0 .163.003.325.009.486H77a6 6 0 01-6-6v-124a6 6 0 016-6z"
          fill="url(#prefix__paint1_linear)"
        />
        <Path
          d="M93.02 74.524l1.997-.115-.11-1.885H93.02v2zm23.96 0v-2h-1.888l-.109 1.885 1.997.115zm.503 136l-1.998-.075-.078 2.075h2.076v-2zm-25.39 0v2h2.077l-.079-2.075-1.998.075zm.927-138H77v4h16.02v-4zM105 83.82c-5.325 0-9.679-4.164-9.983-9.411l-3.993.231c.425 7.351 6.52 13.18 13.976 13.18v-4zm9.983-9.411c-.304 5.247-4.658 9.41-9.983 9.41v4c7.457 0 13.55-5.828 13.976-13.179l-3.993-.231zM133 72.524h-16.02v4H133v-4zm8 8a8 8 0 00-8-8v4a4 4 0 014 4h4zm0 124v-124h-4v124h4zm-8 8a8 8 0 008-8h-4a4 4 0 01-4 4v4zm-15.517 0H133v-4h-15.517v4zm-1.99-2.486c0 .138-.003.275-.008.411l3.997.151c.007-.187.011-.374.011-.562h-4zm-10.705-10.705c5.912 0 10.705 4.793 10.705 10.705h4c0-8.121-6.584-14.705-14.705-14.705v4zm-10.704 10.705c0-5.912 4.792-10.705 10.704-10.705v-4c-8.12 0-14.704 6.584-14.704 14.705h4zm.007.411a10.756 10.756 0 01-.007-.411h-4c0 .188.003.375.01.562l3.998-.151zM77 212.524h15.093v-4H77v4zm-8-8a8 8 0 008 8v-4a4 4 0 01-4-4h-4zm0-124v124h4v-124h-4zm8-8a8 8 0 00-8 8h4a4 4 0 014-4v-4z"
          fill="#E40046"
          fillOpacity={0.1}
          mask="url(#prefix__c)"
        />
        <Path
          d="M97.336 111c.367 0 .668.298.627.663a6.006 6.006 0 01-3.047 4.581 6.005 6.005 0 01-5.499.172c-.33-.158-.425-.571-.232-.883.194-.312.602-.403.938-.255a4.67 4.67 0 006.501-3.616c.052-.363.345-.662.712-.662zM112.881 110.495c-.352-.104-.725.098-.789.459a5.994 5.994 0 001.224 4.795 5.996 5.996 0 004.41 2.245c.367.016.645-.303.621-.67-.024-.366-.341-.638-.707-.667a4.667 4.667 0 01-4.263-5.326c.052-.363-.144-.733-.496-.836z"
          fill="#4A0017"
        />
        <Path
          d="M111.401 128.729c.466 0 .849-.379.798-.842a7.627 7.627 0 00-7.576-6.781 7.625 7.625 0 00-7.576 6.781c-.052.463.33.842.797.842.466 0 .838-.38.904-.841a5.933 5.933 0 0110.071-3.355 5.925 5.925 0 011.678 3.355c.066.461.438.841.904.841z"
          fill="#FF7587"
        />
      </G>
      <Defs>
        <LinearGradient
          id="prefix__paint0_linear"
          x1={13.449}
          y1={80.247}
          x2={114.331}
          y2={194.014}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE2C0" />
          <Stop offset={1} stopColor="#FFB660" />
        </LinearGradient>
        <LinearGradient
          id="prefix__paint1_linear"
          x1={71}
          y1={75}
          x2={139}
          y2={211}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFC4C4" />
          <Stop offset={1} stopColor="#FF7294" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
